import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import NotesOverview from "./index";
import ViewNote from "./ViewNote";
import NewNote from "./NewNote";
import ShareNotes from "./ShareNotes";
import SharedNotes from "./SharedNotes";
import ShareNoteById from "./ShareNoteById";

const NotesRouter = () => {
  return (
    <Routes>
      <Route index element={<NotesOverview />} />
      <Route path="new-note" element={<NewNote />} />
      <Route path="view/:id" element={<ViewNote />} />
      <Route path="share-notes" element={<ShareNotes />} />
      <Route path="shared-notes" element={<SharedNotes />} />
      <Route path="share-note/:id" element={<ShareNoteById />} />
      <Route path="*" element={<Navigate to="." replace />} />
    </Routes>
  );
};

export default NotesRouter;
